import { Component, EventEmitter, Output, Input, signal, WritableSignal, OnInit } from '@angular/core';
import {TableRow, TableColumn} from '../../../../../shared/models/components/tables/table.models';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TableModule } from 'primeng/table';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { TooltipModule } from 'primeng/tooltip';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-inputs-table',
    imports: [CommonModule, FormsModule, FontAwesomeModule, TableModule, TooltipModule],
    templateUrl: './inputs-table.component.html',
    styleUrl: './inputs-table.component.scss'
})
export class InputsTableComponent implements OnInit {
  @Input() columns!: WritableSignal<TableColumn[]>;
  @Input() rows!: WritableSignal<TableRow[]>;
  @Input() canEditChevronCase: boolean = false;
  @Input() chevronDirty: boolean = false; // indicates unsaved changes in Chevron Case
  @Input() savingChevron: boolean = false; // indicates saving in progress
  @Input() preparingChevronConfirm: boolean = false;
  @Input() resetting: boolean = false; 
  @Output() valueChanged = new EventEmitter<{row: TableRow; field: string}>();
  @Output() deleteColumn = new EventEmitter<string>();
  @Output() saveChevron = new EventEmitter<void>();
  faXmark=faXmark;

  ngOnInit(): void {

  }

  onSaveChevronClicked(){
    if(!this.canEditChevronCase){
      return;
    }
    this.saveChevron.emit();
  }

  get frozenColumns(): TableColumn[] {
    return this.columns().filter(col => col.isFrozen);
  }

  get nonFrozenColumns(): TableColumn[] {
    return this.columns().filter(col => !col.isFrozen);
  }

  removeColumn(field:string){
    this.deleteColumn.emit(field)
  };

  validateNumberInput(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    if (allowedKeys.includes(event.key)) {
      return;
    }

    const inputEl = event.target as HTMLInputElement;

    if (event.key === '-') {
      const hasMinus = inputEl.value.includes('-');
      const cursorAtStart = inputEl.selectionStart === 0;
      if (!hasMinus && cursorAtStart) {
        return; 
      }
      event.preventDefault();
      return;
    }

    if (event.key === '.') {
      const hasDot = inputEl.value.includes('.');
      if (hasDot) {
        event.preventDefault();
        return;
      }
      return;
    }

    const regex = /[0-9.,]/; 
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }
  
  validatePaste(event: ClipboardEvent) {
    const pastedText = (event.clipboardData?.getData('text') ?? '').trim();
    const regex = /^-?\d{1,3}(,\d{3})*(\.\d+)?$|^-?\d+(\.\d+)?$/;
    if (!regex.test(pastedText)) {
      event.preventDefault();
    }
  }

  onModelChange(row: TableRow, field: string) {
    this.valueChanged.emit({ row, field });
  }

  getTooltipText(row: TableRow, column: TableColumn, columnIndex: number): string {
    const value = row[column.field];
    
    if (columnIndex !== 0) {
      return '';
    }
    
    return row.description || '';
  }



  getRowClass(row: TableRow): string {
    const category = row.dataCategory?.toLowerCase() || 'default';
    return `${category}-row`;
  }
  
  
}

